<template>
	<div class="product-promotion main-content-padding">
		<Panel :content-padding-top="12" :class="{ comingSoon: $isPlatOr(platformId, ['Sp']) }">
			<platform-tab @change="handleClick" :platformId="platformId"></platform-tab>
			<template v-if="$isPlatOr(['Dy', 'Ks'])">
				<overview :platformId="platformId" :staticsData="staticsData" v-show="showPlatformContent" />
				<search :platformId="platformId" class="mt-20" ref="search" @onSubmit="onSubmit" v-show="showPlatformContent" />
			</template>
			<div class="flex flex-just-center align-center" style="margin-top: 100px" :class="{ emptySPBox: $isPlatOr(platformId, ['Sp']) }" v-else>
				<emptyPage ref="emptyPage">
					<img slot="image" src="@/assets/public/dev-img.png" alt="" />
					<p class="fz-14 yx-color-text-regular" slot="desc">敬请期待</p>
				</emptyPage>
			</div>
		</Panel>
		<Panel v-show="showPlatformContent" :content-padding-top="8" v-if="$isPlatOr(['Dy', 'Ks'])">
			<div class="pos-rela">
				<el-tabs ref="tabs" v-model="activeTab" @tab-click="tabClick" v-if="tabShow">
					<el-tab-pane
						v-for="item in tabsList"
						:name="item.value"
						:label="`${item.label} ${tabCount[item.key] > 99 ? '99+' : tabCount[item.key]}`"
						:key="item.value"
						class="yx-color-text-secondary"
					></el-tab-pane>
				</el-tabs>
				<div class="pos-abso" style="right: 0; top: 2px">
					<el-button @click="openPromotion">推广审核 ({{ tabCount.waitCount }})</el-button>
					<el-tooltip
						placement="top"
						content="商品推广权益已全部使用，请停止推广商品或联系商务增加权益后，再添加新的推广商品"
						:disabled="num !== immanentTotalNum"
					>
						<el-button type="primary" @click="addGoods" :disabled="num === immanentTotalNum" v-if="hasDrPartnerTag">
							添加商品 ({{ num }} / {{ immanentTotalNum }})
						</el-button>
					</el-tooltip>
				</div>
			</div>
			<!-- <base-table ref="table" class="table" :columns="columns" :list="list" v-loading="loading">
				<Empty slot="empty"></Empty>
			</base-table>
			<yx-pagination
				:total="total"
				:current-page="page.page_index"
				:page-size="page.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			></yx-pagination> -->
			<multi-table ref="multiTable" :columns="columns" @gePartnerList="tabGetList" :list="list" :total="total" v-loading="loading">
				<Empty slot="empty"></Empty>
			</multi-table>
		</Panel>

		<!-- 推广动态 -->
		<promotion-dynamics ref="promotionDynamics" />

		<!-- 编辑/添加商品 -->
		<select-goods-drawer :platformId="platformId" ref="selectGoodsDrawer" @selectGoods="selectGoods" />

		<!-- 添加推广机制 -->
		<add-promotion-goods ref="addPromotionGoods" :platformId="platformId" @replaceGoods="replaceGoods" @refresh="refreshList" />

		<!-- 推广审核 -->
		<promotion-review :platformId="platformId" ref="promotionReview" />
	</div>
</template>
<script>
import { platformMixin } from '@rd/rd-ui';
import search from './components/search.vue';
import overview from './components/overview.vue';
import { dyColumns, ksColumns } from './columns.js';
import promotionDynamics from './components/promotionDynamics.vue';
import selectGoodsDrawer from './components/selectGoodsDrawer.vue';
import addPromotionGoods from './components/addPromotionGoods.vue';
import promotionReview from './components/promotionReview.vue';
import emptyPage from '@/views/common/empty/index.vue';
import {
	productTeamList,
	productCommonClose,
	productCommonDelete,
	productCommonOpen,
	productTeamCount,
	teamListStatics,
	privilege,
} from '@/api/secondColonelManage';
import { mapGetters } from 'vuex';

export default {
	components: {
		search,
		overview,
		promotionDynamics,
		selectGoodsDrawer,
		addPromotionGoods,
		promotionReview,
		emptyPage,
	},
	mixins: [platformMixin],
	computed: {
		...mapGetters(['hasDrPartnerTag']),
		columns({ platformId }) {
			const column = {
				[dataMap.PLATFORM_DY.value]: dyColumns,
				[dataMap.PLATFORM_KS.value]: ksColumns,
			};
			return column[platformId];
		},
	},
	data() {
		return {
			list: [],
			params: {},
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			activeTab: '-1',
			tabsList: [
				{
					label: '全部',
					value: '-1',
					key: 'total',
					number: '',
				},
				{
					label: '推广中',
					value: '1',
					key: 'goingCount',
					number: '',
				},
				{
					label: '中止推广',
					value: '2',
					key: 'closeCount',
					number: '',
				},
			],
			page: {
				page_index: 1,
				page_size: 10,
			},
			loading: false,
			total: 0,
			staticsList: [],
			tabCount: {
				total: 0,
				goingCount: 0,
				closeCount: 0,
				waitCount: 0,
			},
			tabShow: false,
			staticsData: {},
			immanentTotalNum: 0,
			num: 0,
		};
	},
	created() {
		this.getList();
		this.teamCount();
		this.teamListStatics();
		this.privilegeInfo();
	},
	methods: {
		async getList() {
			const { platformId, activeTab } = this;
			this.loading = true;
			try {
				const { list = [], total = 0 } = await productTeamList({ platformId, ...this.params, promotionStatus: activeTab, ...this.page });
				this.list = list.map(item => {
					return {
						...item,
						operations: this.getButtons(item),
					};
				});
				this.total = total;
				this.loading = false;
			} finally {
				this.loading = false;
			}
		},
		async teamCount() {
			try {
				const data = await productTeamCount({ platformId: this.platformId });
				this.tabCount = data;
			} finally {
				this.tabShow = true;
			}
		},
		async teamListStatics() {
			const data = await teamListStatics({ platformId: this.platformId });
			this.staticsData = data;
		},
		addGoods() {
			this.$refs.selectGoodsDrawer.show();
		},
		refreshList() {
			//解决es同步延迟问题
			this.loading = true;
			let timer = setTimeout(() => {
				this.getList();
				this.teamCount();
				this.teamListStatics();
				this.privilegeInfo();
				clearTimeout(timer);
			}, 1500);
		},
		handleClick(val) {
			this.platformId = val;
			this.params = {};
			if (!this.showPlatformContent) return;
			this.teamCount();
			this.teamListStatics();
			this.$nextTick(this.$refs['search'].onClear());
		},
		onSubmit(val) {
			this.params = val;
			this.getList();
		},
		tabGetList(obj) {
			const { page_index, page_size } = obj;
			this.page.page_index = page_index;
			this.page.page_size = page_size;
			this.getList();
		},
		//获取按钮操作组
		getButtons(item) {
			let arr = [];
			const editGoods = {
				label: '编辑商品',
				type: 'text',
				classType: 2,
				isShow: true,
				click: row => {
					this.$refs.addPromotionGoods.show({
						...row,
						isCommon: true,
						commissionRate: row.baseCommissionRate,
						shopName: row.outerShopName,
						promotionEndTime: row.originPromotionEndTime,
						outerServiceRate: row.commissionRate,
					});
				},
			};
			const status = {
				label: '推广动态',
				type: 'text',
				classType: 2,
				isShow: true,
				click: ({ productCommonId }) => {
					this.$refs.promotionDynamics.show(productCommonId);
				},
			};
			const text = {
				1: '关闭推广',
				2: '开启推广',
			};
			const promotion = {
				label: text[item.promotionStatus],
				type: 'text',
				classType: 2,
				isShow: true,
				click: ({ productCommonId }) => {
					const content = {
						1: '中止推广后商品讲不在团长的商品公海进行展示，已经成功报名的商品保持不变',
						2: '开启后商品讲在团长的商品公海进行展示，已经成功报名的商品保持不变',
					};
					this.$modal({
						title: `确认${text[item.promotionStatus]}`,
						contentTitle: `${content[item.promotionStatus]}`,
						size: 'small',
						btns: [
							{
								type: 'default',
								text: '取消',
								key: 'cancel',
							},
							{
								type: 'primary',
								text: `确定${text[item.promotionStatus]}`,
								key: 'confirm',
							},
						],
					}).then(async res => {
						if (res.key == 'confirm') {
							let api = {
								1: productCommonClose,
								2: productCommonOpen,
							};
							await api[item.promotionStatus]({ id: productCommonId });
							this.$message.success('操作成功！');
							this.refreshList();
							res.done();
						} else {
							res.done();
						}
					});
				},
			};
			const deleteGoods = {
				label: '删除商品',
				type: 'text',
				classType: 2,
				isShow: item.promotionStatus === '2', //推广中的不支持删除
				click: ({ productCommonId }) => {
					this.$modal({
						title: '确认删除商品',
						contentTitle: '商品公海页面不再展示该商品，可重新添加该商品',
						size: 'small',
						btns: [
							{
								type: 'default',
								text: '取消',
								key: 'cancel',
							},
							{
								type: 'primary',
								text: '确定删除',
								key: 'confirm',
							},
						],
					}).then(async res => {
						if (res.key == 'confirm') {
							await productCommonDelete({ id: productCommonId });
							this.$message.success('操作成功！');
							this.refreshList();
							res.done();
						} else {
							res.done();
						}
					});
				},
			};
			arr.push(editGoods, status, promotion, deleteGoods);
			return arr.filter(item => item.isShow);
		},
		async privilegeInfo() {
			const { initNum = 0, num = 0 } = await privilege({ code: 'goods_seas_num' });
			this.num = num;
			this.immanentTotalNum = initNum;
		},
		tabClick() {
			this.getList();
		},
		selectGoods(row) {
			this.$refs.addPromotionGoods.show(row);
		},
		replaceGoods(row) {
			this.$refs.selectGoodsDrawer.show(this.row);
		},
		openPromotion() {
			this.$refs.promotionReview.show();
		},
	},
};
</script>
<style lang="less" scoped>
.table {
	::v-deep .el-button {
		font-size: 12px !important;
	}
}
</style>
